import React, { useContext } from 'react';

import { Context } from '@store/store';

import { Wrapper, Page, Text } from './item.styles';

const Item = ({ page, text }) => {
  const [, dispatch] = useContext(Context);

  const handleClick = () => {
    const pageToGoTo = page - 1;
    dispatch({
      type: 'SET_CURRENT_PAGE',
      payload: pageToGoTo,
    });
  };

  return (
    <Wrapper>
      <Page
        onClick={handleClick}
      >
        Стр. {page}
      </Page>
      <Text onClick={handleClick} className="search-result">{text}</Text>
    </Wrapper>
  );
};

export default Item;
